window.toggle = function (clickedElement) {
    const label = document.querySelector(`label[for="${clickedElement.id}"]`);
    if (label) {
        const onLabel = clickedElement.dataset.labelOn || 'On';
        const offLabel = clickedElement.dataset.labelOff || 'Off';
        label.textContent = clickedElement.checked ? onLabel : offLabel;
    }
};

// Function to toggle the canary bar visibility using a class
window.toggleCanaryBar = function () {
    const canaryBar = document.querySelector('.mcp-canary-bar');
    if (canaryBar) {
        canaryBar.classList.toggle('hidden');
    }
};
